import React, {useState, useContext, useRef, useEffect} from 'react';
import { IonContent, IonText, IonHeader, IonImg, IonTitle, IonToolbar, IonItem, IonList, IonMenuButton, IonButton, IonButtons, IonInput, IonModal, IonGrid, IonRow, IonCol, IonDatetime, IonFooter, IonLoading } from '@ionic/react';
import { IonSlides, IonSlide, IonLabel } from '@ionic/react';
import { useHistory} from "react-router-dom";

import { EnterPasswordModal } from '../../../zInternal_Features/merchant/components/Modal_EnterPassword';
import { Auth_MerchantID_context } from '../../../../storeState/auth_merchantID_context';

import { TakePhoto, photos } from '../../../zInternal_Features/merchant/components/TakePhoto';

import '../../../css/layout.css';

import { Preferences } from '@capacitor/preferences'

function setFunction_initialSetup(event) {

    Preferences.set({
        key: 'initial_setup',
        //value: event,
        value: JSON.stringify({
            setup_id: event[0],
            details: event[1],
            status: event[2],
            dateCreated: event[3],
            lastModified: event[4],
        })

    })

}

export function AddPortfolioModal (props) {

    //alert('inside CreateEmployeeModal');
    //alert(props.openModal);

    let authenticatedMerchent_context = useContext(Auth_MerchantID_context);

    const [acctID, setAcctID] = useState(authenticatedMerchent_context.acctID);
    const [schema, setSchemaName] = useState(authenticatedMerchent_context.schema);
    let [sessionID, setSessionID ] = useState(authenticatedMerchent_context.sessionID);
    let [baseURL, setBaseURL ] = useState(authenticatedMerchent_context.baseURL);

    let [accessRights, setAccessRights ] = useState(authenticatedMerchent_context.accessRights);


    let [selectedFile, setSelectedFile] = useState(null);

    let [portfolioID, setPortfolioID] = useState(null);
    let [portfolioDateCreated, setPortfolioDateCreated] = useState(null);
    let [portfolioPic1, setPortfolioPic1] = useState(null);
    let [portfolioPic2, setPortfolioPic2] = useState(null);
    let [portfolioPic3, setPortfolioPic3] = useState(null);
    let [portfolioPic4, setPortfolioPic4] = useState(null);
    let [portfolioPic5, setPortfolioPic5] = useState(null);
    let [portfolioPic6, setPortfolioPic6] = useState(null);
    let [portfolioPic7, setPortfolioPic7] = useState(null);
    let [portfolioPic8, setPortfolioPic8] = useState(null);

    let [takePhotoStatus1, setTakePhotoStatus1] = useState(false);
    let [takePhotoStatus2, setTakePhotoStatus2] = useState(false);
    let [takePhotoStatus3, setTakePhotoStatus3] = useState(false);
    let [takePhotoStatus4, setTakePhotoStatus4] = useState(false);
    let [takePhotoStatus5, setTakePhotoStatus5] = useState(false);
    let [takePhotoStatus6, setTakePhotoStatus6] = useState(false);
    let [takePhotoStatus7, setTakePhotoStatus7] = useState(false);
    let [takePhotoStatus8, setTakePhotoStatus8] = useState(false);

    let [isloading, setLoading] = useState(false);

    let [portfolioPicsModal, setPortfolioPicsModal] = useState(false);

    let [portfolioImageNumber, setPortfolioImageNumber] = useState(null);

    let [showPasswordModal, setShowPasswordModal] = useState(false);

    let [row_1, setRow_1] = useState(true);
    let [row_2, setRow_2] = useState(true);
    let [row_3, setRow_3] = useState(false);
    let [row_4, setRow_4] = useState(false);
    let [row_5, setRow_5] = useState(false);
    let [row_6, setRow_6] = useState(false);
    let [row_7, setRow_7] = useState(false);
    let [row_8, setRow_8] = useState(false);
    let [row_9, setRow_9] = useState(false);



    // let createPortfolioAddition_type = useRef(props.data.addition_type);
    // let createPortfolioTypeRef = useRef(props.data.itemType);
    // let createPortfolioDescriptionRef = useRef(props.data.itemDescription);
    // let createPortfolioPartNumRef = useRef(props.data.vendorPartNum);
    // let createPortfolioPhoneNumberRef = useRef(props.data.vendorPartNum);
    // let createPortfolioAddressRef = useRef(props.data.vendorAddress);
    // let createPortfolioCityRef = useRef(props.data.vendorCity);
    // let createPortfolioCountryRef = useRef(props.data.vendorCountry);
    // let createPortfolioCostPerUnitRef = useRef(props.data.costPerUnit);
    // let createPortfolioSalePriceRef = useRef(props.data.salePrice);
    // let createPortfolioQtyInUse = useRef(props.data.qtyInUse);
    // let createPortfolioDateCreated = useRef(props.data.dateCreated);
    // let createPortfolioAddedBy = useRef(props.data.addedBy);


    let [createPortfolioName, setCreatePortfolioName] = useState(null);
    let [createPortfolioDescription, setCreatePortfolioDescription] = useState(null);

    let history = useHistory();

    function handleRoute(event)
    {
        //alert(authenticatedMerchent_context.authenticated);

        //history.push(event);
        window.location.pathname = event;

    }

    function selectedFileHandler1(event)
    {

        setPortfolioImageNumber("1");
        setPortfolioPic1(event);
        setTakePhotoStatus1(false);
    }

    function selectedFileHandler2(event)
    {
        setPortfolioImageNumber("2");
        setPortfolioPic2(event);
        setTakePhotoStatus2(false);
    }
    function selectedFileHandler3(event)
    {
        setPortfolioImageNumber("3");
        setPortfolioPic3(event);
        setTakePhotoStatus3(false);
    }
    function selectedFileHandler4(event)
    {
        setPortfolioImageNumber("4");
        setPortfolioPic4(event);
        setTakePhotoStatus4(false);
    }
    function selectedFileHandler5(event)
    {
        setPortfolioImageNumber("5");
        setPortfolioPic5(event);
        setTakePhotoStatus5(false);
    }
    function selectedFileHandler6(event)
    {
        setPortfolioImageNumber("6");
        setPortfolioPic6(event);
        setTakePhotoStatus6(false);
    }
    function selectedFileHandler7(event)
    {
        setPortfolioImageNumber("7");
        setPortfolioPic7(event);
        setTakePhotoStatus7(false);
    }
    function selectedFileHandler8(event)
    {
        setPortfolioImageNumber("8");
        setPortfolioPic8(event);
        setTakePhotoStatus8(false);
    }
    
    function handle_no_attachement(event) {  

        fetch(baseURL+'fileServer/merchants/image-not-available.jpeg')
        .then(res => res.blob())
        .then(data => {

            const blobUrl = URL.createObjectURL(data);

            let noImageFile = new File([data], blobUrl, {
                enctype: 'multipart/form-data',
                type: 'image/jpeg',
                name: 'xImageFile',
                accept: "image/*",
            });
            
            setPortfolioImageNumber(event[0]);
            setPortfolioPic1(noImageFile);
            setPortfolioPic2(noImageFile);
            setPortfolioPic3(noImageFile);
            setPortfolioPic4(noImageFile);
            setPortfolioPic5(noImageFile);
            setPortfolioPic6(noImageFile);
            setPortfolioPic7(noImageFile);
            setPortfolioPic8(noImageFile);

            alert("No portfolio Pics Option checked");

        })
    }




    function createPortfolio(adminPassword)
    {
        
        setLoading(true);

        //alert("In Crate portfolio Function");
       //alert(schema);
       //alert(createPortfolioPartNum);
       //alert(createPortfolioPhoneNumber);
       //alert(createPortfolioCostPerUnit);
       // alert(pic4.value);
       //alert(totalportfolioPics);

        
        let formData = new FormData();
        //formData.append('xportfolioPics', totalportfolioPics);
        //formData.append('xportfolioPics', [portfolioPic1, portfolioPic2, portfolioPic3, portfolioPic3]);
        formData.append('Tracker', '74300_add_porftolio');
        formData.append('user', acctID);
        formData.append('merchantSchema', schema);
        formData.append('xPortfolioName', createPortfolioName);
        formData.append('xPortfolioDescription', createPortfolioDescription);
        //formData.append('xEnterAdminPassword', adminPassword);
        formData.append('sessionID', sessionID);
        formData.append('xPortfolioPic1', portfolioPic1);
        formData.append('xPortfolioPic2', portfolioPic2);
        formData.append('xPortfolioPic3', portfolioPic3);
        formData.append('xPortfolioPic4', portfolioPic4);
        formData.append('xPortfolioPic5', portfolioPic5);
        formData.append('xPortfolioPic6', portfolioPic6);
        formData.append('xPortfolioPic7', portfolioPic7);
        formData.append('xPortfolioPic8', portfolioPic8);

        const requestOptions = {
            enctype: 'multipart/form-data',
            method:'POST',
            //credentials: 'include',
            file: formData,
            body: formData,
            contentType: false,
            processData: false,
        }
        


        fetch(baseURL+'proService_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(data => {

            alert(data);
            setLoading(false);

            //props.closeModal(false)

            if(authenticatedMerchent_context.initialSetup?.details?.step_2 == false)
            {
                //alert("Inside authenticatedMerchent_context.initialSetup?.details?.step_1");
                updateInitialSetup({step_1: true, step_2: true});
                activateMerchant_initial();
            }
            else
            {
                handleRoute('/proService_merchantMainPageApp');
            }


        })
        .catch(error => {
            console.error(error);
        })
    }


    function updateInitialSetup(event) {

        // alert("in updateInitialSetup");
        // alert(event);
 
 
         let formData = new FormData();
         formData.append('Tracker', '74003B_update_initialSetup');
         formData.append('user', acctID);
         formData.append('xInitialSetup_id', authenticatedMerchent_context.initialSetup.setup_id);
         formData.append('xInitialSetup_details', JSON.stringify(event));
         formData.append('sessionID', sessionID);
 
 
         const requestOptions = {
             enctype: 'multipart/form-data',
             method: 'POST',
             credentials: 'include',
             headers: {
                 'Accept': 'text/html, application/json',
                 //'content-type': 'application/json',
              },
             file: formData,
             body: formData,
             contentType: false,
             processData: false,
             /*body: JSON.stringify({
                 Tracker: '72001B',
                 user: acctID,
             })*/
         }
 
         fetch(baseURL+"proService_merchantAcct_argsjqApp",requestOptions)
         .then(res => res.text())
         .then(res => {
 

            let rows = res.toString().split('~~~');
            let lines3 = rows[0].split('|');
            
             setFunction_initialSetup([lines3[0], lines3[1]]);


             let initialSetupParsed = {};
                
             try {
             initialSetupParsed = JSON.stringify({
                 setup_id: lines3[0],
                 details: lines3[1],
                 status: lines3[2],
                 dateCreated: lines3[3],
                 lastModified: lines3[4],
             })
                 ? JSON.parse(JSON.stringify({
                     setup_id: lines3[0],
                     details: lines3[1],
                     status: lines3[2],
                     dateCreated: lines3[3],
                     lastModified: lines3[4],
                 })) : {};

             if (typeof initialSetupParsed.details === 'string') {
                 initialSetupParsed.details = JSON.parse(initialSetupParsed.details);
             }
             } catch (e) {
             console.warn('Error parsing initialSetup:', e);
             initialSetupParsed = {};
             }

          authenticatedMerchent_context.changeInitialSetup(initialSetupParsed); 
            
             //alert("UPDATE COMPLETE");

             //handleRoute('/proService_merchantMainPageApp');
         })
     }

      function activateMerchant_initial() {

        // alert("in updateInitialSetup");
        // alert(event);
 
 
         let formData = new FormData();
         formData.append('Tracker', '00_activate_merchant_initial');
         formData.append('user', acctID);
         formData.append('sessionID', sessionID);
 
 
         const requestOptions = {
             enctype: 'multipart/form-data',
             method: 'POST',
             credentials: 'include',
             headers: {
                 'Accept': 'text/html, application/json',
                 //'content-type': 'application/json',
              },
             file: formData,
             body: formData,
             contentType: false,
             processData: false,
             /*body: JSON.stringify({
                 Tracker: '72001B',
                 user: acctID,
             })*/
         }
 
        fetch(baseURL+'ghanaverified/', requestOptions)
         .then(res => res.text())
         .then(res => {
 

            let rows = res.toString().split('~~~');
            let lines = rows[0].split('|');
            
            
             alert(lines[1]);

             handleRoute('/proService_merchantMainPageApp');
         })
     }


    function saveUploadedFile(event) {
    
        //alert(event);
        
        if(event.target.files === null)
        {
            //selectedFile = "/home/tkweifio/Documents/LocalKuaye/Forms/web/Public/fileServer/merchants/image-not-available.jpg";
            setSelectedFile("/home/tkweifio/Documents/LocalKuaye/Forms/web/Public/fileServer/merchants/image-not-available.jpg")

        }
        else
        {
            //selectedFile = event.target.files[0];
            setSelectedFile(event.target.files[0]);
        }


    }

    function saveportfolioPictures(event) { 

        setPortfolioPic1(event.target.files[0]);
        setPortfolioPic2(event.target.files[1]);
        setPortfolioPic3(event.target.files[2]);
        setPortfolioPic4(event.target.files[3]);
    
    
    }


    function handleFileChange(event) {

        //alert("in HadndleFileChange");
        //alert(event[0]);
        //alert(event.target.dataset.id);
        // alert(event.target);
        // alert(event.target.files);
        // alert(event.target.files[0]);

        if(event.target.dataset.id == "1")
        {
            const file = event.target.files ? event.target.files[0] : null;
            setPortfolioImageNumber("1");
            setPortfolioPic1(file);
        }
        if(event.target.dataset.id == "2")
        {
            const file = event.target.files ? event.target.files[0] : null;
            setPortfolioImageNumber("2");
            setPortfolioPic2(file);
        }
        if(event.target.dataset.id == "3")
        {
            const file = event.target.files ? event.target.files[0] : null;
            setPortfolioImageNumber("3");
            setPortfolioPic3(file);
        }
        if(event.target.dataset.id == "4")
        {
            const file = event.target.files ? event.target.files[0] : null;
            setPortfolioImageNumber("4");
            setPortfolioPic4(file);
        }

        if(event.target.dataset.id == "5")
        {
            const file = event.target.files ? event.target.files[0] : null;
            setPortfolioImageNumber("5");
            setPortfolioPic5(file);
        }
        if(event.target.dataset.id == "6")
        {
            const file = event.target.files ? event.target.files[0] : null;
            setPortfolioImageNumber("6");
            setPortfolioPic6(file);
        }
        if(event.target.dataset.id == "7")
        {
            const file = event.target.files ? event.target.files[0] : null;
            setPortfolioImageNumber("7");
            setPortfolioPic7(file);
        }
        if(event.target.dataset.id == "8")
        {
            const file = event.target.files ? event.target.files[0] : null;
            setPortfolioImageNumber("8");
            setPortfolioPic8(file);
        }
    }

    function onSubmitPasswordHandler(enteredPassword)
    {
        //alert('In onSubmitPasswordHandler');

        //setEnteredPassword(event);
        createPortfolio(enteredPassword);
    }

    function closeModalHandler() {

        props.closeModal(false);
    }

    useEffect(() => {

        setSelectedFile("/home/tkweifio/Documents/LocalKuaye/Forms/web/Public/fileServer/merchants/image-not-available.jpg");
        handle_no_attachement();

    }, [])
    
    //alert("IN CREATE portfolio")

    return (
        <React.Fragment>
        {props.openModal == true ?
        (
        <IonModal isOpen={ props.openModal }>
            <IonHeader >
                    <IonToolbar>
                    <IonTitle>{"ADD PORTFOLIO"}</IonTitle>
                    <IonButtons slot="end">
                        <IonButton fill="outline" color="success" onClick={closeModalHandler}>Close</IonButton>
                    </IonButtons>
                    </IonToolbar>
            </IonHeader> 
             <IonContent className='grid_content'>
                    <IonGrid>
                        <IonRow> 
                            <IonCol>
                                <IonLabel>portfolio Name: </IonLabel>
                            </IonCol>
                            <IonCol size='6'>
                                <IonInput className='professional-input' type='text' value={createPortfolioName} placeholder='Enter Portfolio Name' autocomplete='off' onIonChange={(e) => setCreatePortfolioName(e.target.value)} required></IonInput>
                            </IonCol>
                        </IonRow>

                        <IonRow>
                            <IonCol>
                            <IonLabel>Portfolio Description:</IonLabel>
                            </IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol>
                                <textarea cols="40" rows="10"  value={createPortfolioDescription} placeholder="Enter Portfolio Description" onChange={(e) => setCreatePortfolioDescription(e.target.value)} ></textarea>
                            </IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol> 1/8 </IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol>                            
                                <IonButton  onClick={() => setTakePhotoStatus1(true)}> Take Photo</IonButton>
                                {takePhotoStatus1 == true && <TakePhoto onSelectedFile={selectedFileHandler1}></TakePhoto>}
                            </IonCol>
                            <IonCol>
                                <input
                                    type="file"
                                    accept="image/jpeg"
                                    data-id='1'
                                    onChange={handleFileChange}
                                />
                            </IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol> 2/8 </IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol>                            
                                <IonButton  onClick={() => setTakePhotoStatus2(true)}> Take Photo</IonButton>
                                {takePhotoStatus2 == true && <TakePhoto onSelectedFile={selectedFileHandler2}></TakePhoto>}
                            </IonCol>
                            <IonCol>
                                <input
                                    type="file"
                                    accept="image/jpeg"
                                    data-id='2'
                                    onChange={handleFileChange}
                                />
                            </IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol> 3/8 </IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol>                            
                                <IonButton  onClick={() => setTakePhotoStatus3(true)}> Take Photo</IonButton>
                                {takePhotoStatus3 == true && <TakePhoto onSelectedFile={selectedFileHandler3}></TakePhoto>}
                            </IonCol>
                            <IonCol>
                                <input
                                    type="file"
                                    accept="image/jpeg"
                                    data-id='3'
                                    onChange={handleFileChange}
                                />
                            </IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol> 4/8 </IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol>                            
                                <IonButton  onClick={() => setTakePhotoStatus4(true)}> Take Photo</IonButton>
                                {takePhotoStatus4 == true && <TakePhoto onSelectedFile={selectedFileHandler4}></TakePhoto>}
                            </IonCol>
                            <IonCol>
                                <input
                                    type="file"
                                    accept="image/jpeg"
                                    data-id='4'
                                    onChange={handleFileChange}
                                />
                            </IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol> 5/8 </IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol>                            
                                <IonButton  onClick={() => setTakePhotoStatus5(true)}> Take Photo</IonButton>
                                {takePhotoStatus5 == true && <TakePhoto onSelectedFile={selectedFileHandler5}></TakePhoto>}
                            </IonCol>
                            <IonCol>
                                <input
                                    type="file"
                                    accept="image/jpeg"
                                    data-id='5'
                                    onChange={handleFileChange}
                                />
                            </IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol> 6/8 </IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol>                            
                                <IonButton  onClick={() => setTakePhotoStatus6(true)}> Take Photo</IonButton>
                                {takePhotoStatus6 == true && <TakePhoto onSelectedFile={selectedFileHandler6}></TakePhoto>}
                            </IonCol>
                            <IonCol>
                                <input
                                    type="file"
                                    accept="image/jpeg"
                                    data-id='6'
                                    onChange={handleFileChange}
                                />
                            </IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol> 7/8 </IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol>                            
                                <IonButton  onClick={() => setTakePhotoStatus7(true)}> Take Photo</IonButton>
                                {takePhotoStatus7 == true && <TakePhoto onSelectedFile={selectedFileHandler7}></TakePhoto>}
                            </IonCol>
                            <IonCol>
                                <input
                                    type="file"
                                    accept="image/jpeg"
                                    data-id='7'
                                    onChange={handleFileChange}
                                />
                            </IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol> 8/8 </IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol>                            
                                <IonButton  onClick={() => setTakePhotoStatus8(true)}> Take Photo</IonButton>
                                {takePhotoStatus8 == true && <TakePhoto onSelectedFile={selectedFileHandler8}></TakePhoto>}
                            </IonCol>
                            <IonCol>
                                <input
                                    type="file"
                                    accept="image/jpeg"
                                    data-id='8'
                                    onChange={handleFileChange}
                                />
                            </IonCol>
                        </IonRow>
                    </IonGrid>


            {isloading == true && <IonLoading
                isOpen={isloading}
                message={'Please wait...'}
                duration={0} // Show until manually dismissed
            />}

        </IonContent>
        <IonFooter class='grid_footer'>
                <IonGrid>
                    <IonRow>
                        <IonCol size='12'>
                            {(authenticatedMerchent_context.initialSetup?.details?.step_1 == true && authenticatedMerchent_context.initialSetup?.details?.step_2 == false) ?
                            <IonButton className='flash-tutorial'  onClick={() => createPortfolio()}> SUBMIT </IonButton>
                            : <IonButton onClick={() => createPortfolio()}> SUBMIT </IonButton>
                            }
                        </IonCol>
                    </IonRow>
                </IonGrid>
        </IonFooter>
        </IonModal>
        ) : null}
        </React.Fragment>
        )
}